import React, {
  FunctionComponent,
  useState,
  useMemo,
  useEffect,
} from "react";
import { Form, Button } from "semantic-ui-react";
import { Translate } from "react-redux-i18n";

import { getImagePath } from "../../helpers/imageUrlHelper"
import { ImageUpload, ImageUploadProps } from "../common/imageUpload";
import { FieldErrorMessage } from './fieldErrorMessage';

export interface ImageUploadInputProps extends Omit<ImageUploadProps, "clearable"> {
  url: string | null;
  id?: string;
  label?: string;
  subtext?: string;
  required?: boolean;
  validationErrorMessage?: string;
}

export const ImageUploadInput: FunctionComponent<ImageUploadInputProps> = ({
  validationErrorMessage,
  ...props
}) => {
  const {
    url,
    id,
    label,
    subtext,
    required,
    formats = ["JPEG", "JPG", "PNG"],
    width,
    height,
    ...rest
  } = props;

  const [imageError, setImageError] = useState(false);

  const showImage = useMemo(() => Boolean(url && !imageError), [url, imageError]);

  useEffect(() => setImageError(false), [url]);

  const handleClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    return false;
  };

  return (
    <Form.Field
      id={id}
      required={required}
    >
      <label>{label}</label>
      <ImageUpload
        clearable={showImage}
        disableLoader={true}
        {...props}
      >
        <div className={`default-image-container ${showImage ? "remove-background" : ""}`}>
          {showImage && (
            <img
              alt=""
              className="profile-image"
              onError={() => setImageError(true)}
              src={url?.includes("https://cdn") ? url : getImagePath(url!)}
            />
          )}
        </div>
        <div className="select-image-text">
          <div className="select-image-text-inner">
            <h4>Select an image from your computer</h4>

            {showImage ? (
              <Button
                disabled={rest.disabled}
                content="Change"
                onClick={handleClick}
              />
            ) : (
              <div>
                {formats.join(", ")} format. <br />
                At least {width} x {height} pixels
              </div>
            )}
          </div>
        </div>
      </ImageUpload>

      {subtext && (
        <div className="input-sub">
          <Translate value={subtext} />
        </div>
      )}
      <FieldErrorMessage message={validationErrorMessage} />
    </Form.Field>
  );
};
